// extracted by mini-css-extract-plugin
export var brand = "_a9-9";
export var compact = "_a9-6";
export var extraSmall = "_a9-7";
export var icon = "_a9-0";
export var large = "_a9-4";
export var light = "_a9-1";
export var medium = "_a9-5";
export var outline = "_a9-b";
export var primaryDark = "_a9-a";
export var primaryLight = "_a9-8";
export var primaryModern = "_a9-c";
export var success = "_a9-2";
export var successSolid = "_a9-3";